import {
  selectVideoTrackByID,
  useHMSStore,
  useVideo,
} from "@100mslive/react-sdk";
import type { Peer } from "@/react/types/Live/Peer";

export const useHMSPeerVideo = (peer?: Pick<Peer, "videoTrack">) => {
  const trackId = peer?.videoTrack;
  const { videoRef } = useVideo({ trackId });
  const track = useHMSStore(selectVideoTrackByID(trackId));

  return {
    videoRef,
    hasVideo: Boolean(track?.enabled),
  };
};
